export default function createSetupLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `setup:${input.type}` });
    return {
        notStarted(reason) {
            return log({
                type: "not-started",
                details: { reason },
            });
        },
        started(details) {
            return log({
                type: "started",
                details,
            });
        },
        cancelClicked(taskId) {
            return log({
                type: "cancel-clicked",
                details: { taskId },
            });
        },
        cancelled(taskId, status) {
            return log({
                type: "cancelled",
                details: { taskId, status },
            });
        },
        finishClicked(taskId) {
            return log({
                type: "finish-clicked",
                details: { taskId },
            });
        },
        finished(taskId) {
            return log({
                type: "finished",
                details: { taskId },
            });
        },
    };
}
